import React from "react";
import "../App.css";
import AboutPageDisplay from "../components/AboutPage/AboutPageDisplay";

const Home = () => {
  return (
    <div className="App">
      <header className="App-header">
        <AboutPageDisplay />
      </header>
    </div>
  );
};
export default Home;
